import { render } from "./IDFilters.vue?vue&type=template&id=4837ca4c"
import script from "./IDFilters.vue?vue&type=script&lang=js"
export * from "./IDFilters.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__